import { render, staticRenderFns } from "./DialpadSms.vue?vue&type=template&id=8b4308e0&"
import script from "./DialpadSms.vue?vue&type=script&lang=js&"
export * from "./DialpadSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports